<template>
  <v-app class="primary split-bg">
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 lg8>
            <table width="100%" style="margin-bottom:20px;">
              <tr>
                <td>
                  <img src="/static/transit-logo-print.png" width="160" />
                </td>
                <td align="right">
                  <h2>Factura {{ item.invoiceNumber }}</h2>
                </td>
              </tr>
            </table>

            <v-card v-if="itemLoaded">
              <v-card-text>
                <table class="print-table">
                  <tr>
                    <td class="col-label">Laboratorio</td>
                    <td class="col-label">Distribuidor</td>
                  </tr>
                  <tr>
                    <td class="col-value">{{ item.lab_invoices.name }}</td>
                    <td class="col-value">{{ item.dist_invoices.name }}</td>
                  </tr>
                  <tr>
                    <td class="col-label"># Factura</td>
                    <td class="col-label"># CIF</td>
                  </tr>
                  <tr>
                    <td class="col-value">{{ item.invoiceNumber }}</td>
                    <td class="col-value">{{ item.cif }}</td>
                  </tr>
                  <tr>
                    <td class="col-label"># Bulto</td>
                    <td class="col-label"># Control</td>
                  </tr>
                  <tr>
                    <td class="col-value">{{ item.packageNumber }}</td>
                    <td class="col-value">{{ item.controlNumber }}</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="col-label">Observaciones</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="col-value">
                      {{ item.observations }}
                    </td>
                  </tr>
                </table>

                <br />
                <h4>Productos</h4>
                <table
                  width="100%"
                  class="table-products"
                  cellpadding="8"
                  cellspacing="8"
                >
                  <tr
                    :key="i"
                    v-for="(obj, i) in item.InvoiceProductBatches"
                    class="product-row"
                  >
                    <td>
                      <hr style="margin:5px 0 10px;" />
                      <table width="100%">
                        <tr>
                          <td>
                            <div class="col-label">Nombre</div>
                            <div class="col-value-small">
                              {{ obj.ProductBatch.product.name }}
                            </div>
                            <div class="col-label">Fórmula</div>
                            <div class="col-value-small">
                              {{ obj.ProductBatch.fxFormula }}
                            </div>
                          </td>
                        </tr>
                      </table>

                      <table width="100%">
                        <tr>
                          <td width="20%">
                            <div class="col-label">Reg Sanitario:</div>
                            <span class="col-value-small">
                              {{ obj.ProductBatch.sanitaryReg }}
                            </span>
                          </td>
                          <td width="20%">
                            <div class="col-label"># de Lote:</div>
                            <span class="col-value-small">
                              {{ obj.ProductBatch.batchNumber }}
                            </span>
                          </td>
                          <td width="20%">
                            <div class="col-label">Expiracion:</div>
                            <span class="col-value-small">
                              {{ dateFormat(obj.ProductBatch.expirationDate) }}
                            </span>
                          </td>
                          <td width="20%">
                            <div class="col-label">Certificados:</div>
                            <span class="col-value-small">
                              {{ obj.ProductBatch.certificate ? 'SI' : 'NO' }}
                            </span>
                          </td>
                          <td width="20%">
                            <div class="col-label">Estatus:</div>
                            <span class="col-value-small">
                              {{
                                getLabelByStatus(obj.ProductBatch.batchStatus)
                              }}
                            </span>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </v-card-text>
            </v-card>
            <div v-else>
              Cargando datos
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {
  getColorByStatus,
  getLabelByStatus,
  dateFormat,
} from '@/helpers/TransitHelper'
export default {
  data: () => ({
    item: {},
    itemLoaded: false,
  }),
  created() {
    if ('id' in this.$route.params) {
      this.$store
        .dispatch('invoices/getById', {
          id: this.$route.params.id,
        })
        .then(response => {
          if (response) {
            this.item = response
            this.itemLoaded = true
            this.$nextTick(function() {
              // DOM updated
              setTimeout(window.print, 1000)
            })
          } else {
            this.$router.push('/facturas/listado')
          }
        })
    }
  },
  methods: {
    dateFormat,
    getColorByStatus,
    getLabelByStatus,
  },
}
</script>
<style scope="css">
.print-table {
  width: 100%;
}
.col-label {
  font-size: 12px;
  font-weight: 500;
  color: #777;
}
.col-value {
  font-size: 16px;
  padding-bottom: 10px;
}
.col-value-small {
  font-size: 14px;
  padding-bottom: 10px;
}
#app.primary {
  background-color: #fff !important;
}
</style>
